<template>
  <vx-card class="mt-base" :title="activityTitle">
    <p class="mb-5">
      Teaching and instructing is a large part of working in this industry. You will need to be able
      to break down activities and exercises into small sections to be able to teach a client what
      to do (and safely).
    </p>

    <div class="vx-row my-5 flex items-center justify-center">
      <div class="vx-col xl:w-1/2 lg:w-1/2 w-full my-5">
        <h4 class="mb-5">Your Task:</h4>
        <p class="mb-5">
          Record yourself putting your friend or a family member through a fitness test or one of
          the exercise routines you’ve worked on in previous activities (no more than 3 minutes). It
          doesn’t need to be perfect. In fact, it is better if it isn’t as this will create
          opportunities for you to learn how to do it better in future.
        </p>
        <p class="mb-5">
          As you think about what you need to do, and how; refer to the questions below (you will be
          answering these as part of your task submission) and make sure you cover these things in
          your instruction session with your client.
        </p>
      </div>
      <div class="vx-col xl:w-1/2 lg:w-1/2 w-full my-5">
        <img
          src="@/assets/images/experiences/fitness/strength_training.jpg"
          alt=""
          class="mx-auto img-responsive"
        />
      </div>
    </div>
    <p class="mb-5">When you have recorded your video, you can upload it below.</p>
    <fileupload-button-immediate
      v-model="uploaded_files['uploaded_file_1']"
      :is-editable="isEditable"
      :upload-btn-text="'Upload Video'"
      index="1"
      filetype="media"
    />

    <h4 class="mb-5">Questions:</h4>
    <p class="mb-5">Watch the video to critique yourself by answering the following questions:</p>

    <p class="mb-5">Were you motivating/encouraging?</p>
    <textarea-block v-model="data.question1" :editable="isEditable" />

    <p class="mb-5">Did you explain the exercises properly?</p>
    <textarea-block v-model="data.question2" :editable="isEditable" />

    <p class="mb-5">Did you show them the proper techniques?</p>
    <textarea-block v-model="data.question3" :editable="isEditable" />

    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';

export default {
  data() {
    return {
      videos: {
        1: {
          image: require('@/assets/images/experiences/fitness/strength_video_splash.jpg'),
          url: 'https://www.youtube.com/embed/A-B3GIPWH7g',
        },
      },
      uploaded_files: {
        uploaded_file_1: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
